import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { UserCredentials } from '@arpada/arp-lib-common-qupro';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HouseOwnerContactsService {

  private static HOUSE_OWNER_CONTACTS_URL = '/get-house-owner-contacts';
      private static CREDENTIAL_SEPARATOR = ':';
    private static CREDENTIAL_PREFIX = 'TOKEN-';

  constructor(private httpClient: HttpClient) { }

  public getHouseOwnerContacts(houseId: number): Observable<Object> {
    const httpOptions = {
            headers: new HttpHeaders({
                'app-key': environment.apiToken,
                Authorization: 'Basic ' + btoa(this.getUserCredentialToken()),
                }),
            
        }
    const url = environment.fastapiExposedQuproHouseContactsBaseURL + HouseOwnerContactsService.HOUSE_OWNER_CONTACTS_URL + '/' + houseId;
    return this.httpClient.get(url, httpOptions);
  }
  private getUserCredentialToken(): string {
    const userCredentials: UserCredentials= UserCredentials.load();
    const userCredentialToken: string = userCredentials.getUsername() + HouseOwnerContactsService.CREDENTIAL_SEPARATOR + HouseOwnerContactsService.CREDENTIAL_PREFIX + userCredentials.getTokenPass();
    return userCredentialToken;
  }
}
